// broadcastFilter — resolves the current pathname to a page key
// the admin console uses to scope broadcasts. Keep this map in sync
// with `DISPLAY_PAGES` in AdminBroadcastsPage.js.

const PATH_MATCHERS = [
  { prefix: '/app', key: 'home' },
  { prefix: '/chat', key: 'chat' },
  { prefix: '/bible', key: 'bible' },
  { prefix: '/reflection', key: 'reflection' },
  { prefix: '/community', key: 'community' },
  { prefix: '/study-plans', key: 'study_plans' },
  { prefix: '/settings', key: 'settings' },
  { prefix: '/profile', key: 'profile' },
  { prefix: '/recap', key: 'recap' },
  { prefix: '/did-you-know', key: 'did_you_know' },
];

// Return the page key for a given pathname, or null if the pathname
// is not a known page (e.g. /admin, /affiliate, /login, /signup, /).
// Broadcasts that specifically target pages will not render on
// unknown pages unless the '*' wildcard is set.
export function pathToPageKey(pathname) {
  if (!pathname) return null;
  // Exact match for /app (home) — deeper /app/... routes still count
  // as home unless a more specific matcher below claims them.
  for (const m of PATH_MATCHERS) {
    if (pathname === m.prefix || pathname.startsWith(m.prefix + '/')) {
      return m.key;
    }
  }
  return null;
}

// Filter helper: is this broadcast allowed to render on the given
// pathname? Uses these rules, in order:
//   1. Missing / empty `display_pages` → allowed everywhere (legacy).
//   2. Contains '*' wildcard          → allowed everywhere.
//   3. Contains the current page key  → allowed.
//   4. Otherwise                       → blocked.
export function broadcastAllowedOnCurrentPage(broadcast, pathname) {
  const pages = broadcast && broadcast.display_pages;
  if (!Array.isArray(pages) || pages.length === 0) return true;
  if (pages.includes('*')) return true;
  const key = pathToPageKey(pathname);
  if (!key) return false;
  return pages.includes(key);
}
